export default __webpack_public_path__ + "static/media/cov-19-pass.c1b3ccc2.png";